import React from 'react';
import KlarnaInfo from '@base/common/payMent/Klarna/KlarnaInfo';
import RemindModal from '@base/common/payMent/RemindModal';
import { isPhone } from 'base/utils/client';
import Image from '@base/lib/ThemeImage';
import styles from './index.module.less';

type IProps = {
    className?: string;
    children?: React.ReactNode;
}

const KlarnaRemindModal: React.FC<IProps> = (props) => {

    const { children, className } = props
    return (
        <RemindModal
            className={className}
            modalContent={<KlarnaInfo showTitle={!isPhone}/>}
            modalTitle={(<div className={styles['title-img']}>
                <Image
                    src={'asset/width-300/picture/c1ec8820ff034a06d67b54f4339c3bed.png'}
                    width={75}
                    height={18}
                    background={false}
                />
            </div>)}
        >
            {children}
        </RemindModal>
    )
};

export default KlarnaRemindModal;